import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconPending20pxBoldS = function IconPending20pxBoldS(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 20 20",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "10",
      cy: "10",
      r: "8",
      fill: "#FFBC08"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 5.344a.75.75 0 01.75.75v3.94h2.373a.75.75 0 010 1.5H10a.75.75 0 01-.75-.75v-4.69a.75.75 0 01.75-.75z",
      fill: "#fff"
    })]
  }));
};
export default IconPending20pxBoldS;